import {IconWrapper} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  "data-slot": "icon",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M11.004 18H9A6 6 0 0 1 9 6h5.85m-3.846 12a.586.586 0 0 0-.131-.37A12.499 12.499 0 0 0 8.66 15.5m2.343 2.5c0 .13-.044.262-.131.37A12.5 12.5 0 0 1 8.66 20.5M14.85 6a3.15 3.15 0 1 0 6.3 0 3.15 3.15 0 0 0-6.3 0ZM18 21c-.932 0-1.398 0-1.765-.152a2 2 0 0 1-1.083-1.083C15 19.398 15 18.932 15 18c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.083-1.083C16.602 15 17.068 15 18 15c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C21 16.602 21 17.068 21 18c0 .932 0 1.398-.152 1.765a2 2 0 0 1-1.083 1.083C19.398 21 18.932 21 18 21Z"
    }, null, -1)
  ])))
}
export default { render() { return h(IconWrapper, {icon: {render}, name: "automation"}) } }